module.exports = __webpack_public_path__ + "static/media/Spinner.f7347d37.gif";